module.exports = __webpack_public_path__ + "static/media/logo-full-final.732c66a1.svg";